import { render } from "./ContentTableTypeList.vue?vue&type=template&id=2768126b&scoped=true"
import script from "./ContentTableTypeList.vue?vue&type=script&lang=js"
export * from "./ContentTableTypeList.vue?vue&type=script&lang=js"

import "./ContentTableTypeList.vue?vue&type=style&index=0&id=2768126b&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2768126b"]])

export default __exports__